import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    try { localStorage.setItem("session_token", token); } catch {}
  } else {
    delete api.defaults.headers.common["Authorization"];
    try { localStorage.removeItem("session_token"); } catch {}
  }
};

// Restore on load
try {
  const t = localStorage.getItem("session_token");
  if (t) api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
} catch {}
